import { render, staticRenderFns } from "./pahs-banner-info.html?vue&type=template&id=795cc791&scoped=true&external"
import script from "./pahs-banner-info.js?vue&type=script&lang=js&external"
export * from "./pahs-banner-info.js?vue&type=script&lang=js&external"
import style0 from "./pahs-banner-info.scss?vue&type=style&index=0&id=795cc791&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795cc791",
  null
  
)

export default component.exports